import React, { Component } from 'react';
import dayjs from 'dayjs';
import Select from 'react-select';

import services from './data';

let CategoryOptions;

class FuelList extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      options: [],
    };
  }
  componentDidMount() {
    services
      .getFuelWithPrice(dayjs().format('YYYY-MM-DD'))
      .then((response) => {
        const tmp = response.data.data.fuel_prices;
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].product_uuid,
            label: tmp[i].product_name,
          });
        }
        this.setState({ options: CategoryOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleChange = (selectedOption) => {
    const id = this.props.did ? this.props.did : 0;
    let option = selectedOption;
    if (selectedOption == null) {
      option = { value: '', label: '' };
    }
    this.props.onChange(option, id);
  };

  render() {
    const { options } = this.state;
    return (
      <Select
        onChange={this.handleChange}
        isClearable={true}
        options={options}
        className="select-box-container fuel-selector-container"
        classNamePrefix="fuel-selector"
        name="fuel"
        placeholder="Select fuel"
        value={options.filter(({ value }) => value === this.props.value)}
        isDisabled={this.props.disabled || false}
        menuPortalTarget={document.body}
      />
    );
  }
}

export { FuelList };
